
const getBoardIdListingId = (boardId, listingId) => {
    const bid = `bid=${boardId}`;
    const lid = `lid=${listingId}`;
    if (boardId && listingId) {
        return [bid, lid].join(';');
    }
    if (boardId) {
        return bid;
    }
    if (listingId) {
        return lid;
    }
    return null;
};

const getPositionLabel = (position, total) => {
    return `position=${position + 1};total=${total}`;
};

const getTotal = (total) => {
    return `total=${total}`;
};

export const ENTER_CHAR_CODE = 13;
export const MAX_TRIPBOARD_NAME_LENGTH = 25;
export const GOOGLE_MAPS_CHANNEL_ID = 'homeaway-pulse';

const CONSTANTS = {
    GOOGLE_MAPS_CHANNEL_ID,
    MAX_TRIPBOARD_NAME_LENGTH,
    ENTER_CHAR_CODE,
    EDAP: {
        CHANGE_SEEN: {
            ACTION: 'changeSeen',
            getLabel: getPositionLabel
        }
    },
    OWNER: 'owner',
    VIEWER: 'viewer',
    COLLABORATOR: 'collaborator'
};

export const API_STATUS = {
    START: 'START',
    SUCCESS: 'SUCCESS',
    ERROR: 'ERROR'
};

export const ROLES = {
    COLLABORATOR: 'COLLABORATOR',
    OWNER: 'OWNER',
    VIEWER: 'VIEWER',
    ADMIN: 'ADMIN'
};

const EDAP = {
    CATEGORY: 'Scratchpad',
    CHANGE_SEEN: {
        ACTION: 'changeSeen',
        getLabel: getPositionLabel
    },
    EMAIL_PREFERENCES: 'email preferences',
    TRIP_BOARDS_CATEGORY: 'Tripboards',

    // triggered when trip board summary hit is clicked
    TRIP_BOARDS_BOARD_CLICK: {
        ACTION: 'board.click',
        getLabel: getPositionLabel
    },

    // triggered when user clicks trash icon on trip board (starts the trip board delete flow)
    TRIP_BOARDS_BOARD_DELETE_START: 'board.delete.start',

    // triggered when user clicks, "yes, delete" for the trip board delete flow
    // this gets triggered whether the API call is successful or not (attempt)
    TRIP_BOARDS_BOARD_DELETE_ATTEMPT: 'board.delete.attempt',

    // triggered when user clicks, "cancel" for the trip board delete flow
    TRIP_BOARDS_BOARD_DELETE_CANCEL: 'board.delete.cancel',

    // triggered when user clicks on "edit" and starts edit board flow
    TRIP_BOARDS_BOARD_EDIT_START: 'board.edit.start',

    // triggered when user clicks "cancel" from edit board flow
    TRIP_BOARDS_BOARD_EDIT_CANCEL: 'board.edit.cancel',

    // triggered when user clicks "done" from edit board flow regardless if a change was made
    TRIP_BOARDS_BOARD_EDIT_DONE: 'board.edit.done',

    // triggered when a user has changed the board name and clicked "done"
    // this gets triggered whether the API call is successful or not (attempt)
    TRIP_BOARDS_BOARD_EDIT_NAME: {
        ACTION: 'board.edit.name.attempt',
        getLabel: (oldName, newName) => {
            return `from=${oldName};to=${newName}`;
        }
    },

    // triggered when user clicks listing hit on trip board details
    TRIP_BOARDS_LISTING_CLICK: {
        ACTION: 'listing.click',
        getLabel: getPositionLabel
    },

    // triggered when user clicks "X" on listing hit on trip board details to delete listing
    // this gets triggered whether the API call is successful or not (attempt)
    TRIP_BOARDS_LISTING_DELETE: {
        ACTION: 'listing.delete.attempt',
        getLabel: getPositionLabel
    },

    // triggered when trip board summaries page is loaded
    TRIP_BOARDS_SUMMARIES_LOAD: {
        ACTION: 'board.summary.load',
        getLabel: getTotal
    },

    // triggered when trip board details page is loaded
    TRIP_BOARDS_DETAILS_LOAD: {
        ACTION: 'board.details.load',
        getLabel: getTotal
    },

    getBoardIdListingId
};

export default {...CONSTANTS, EDAP};



// WEBPACK FOOTER //
// ./src/universal/utils/constants.js